/**
 * Financing modes ("modes de financement") — constants & enums.
 * Source of truth: PRD §4.1 + Figma "⛭ Modes de financement".
 */

/** Create vs edit context for the full-screen financing-mode detail page. */
export enum FinancingModeDetailModeEnum {
  CREATE = "create",
  EDIT = "edit",
}

/**
 * Technical code of the single imposed system financing mode.
 * Never renamed, deactivated or deleted (PRD AC-PARAM-01.3 / AC-PARAM-06.2).
 */
export const SYSTEM_FINANCING_MODE_CODE = "BUDGET_ENTREPRISE";

/** Prefix of generated custom technical codes: `custom_financing_mode_1`, `_2`, … */
export const CUSTOM_FINANCING_MODE_CODE_PREFIX = "custom_financing_mode_";

/** Max modes flagged "Proposé par défaut", system mode included (Figma: "Maximum 4 modes par défaut atteint"). */
export const MAX_DEFAULT_FINANCING_MODES = 4;

/** Max financing modes selectable on a single session (BUDGET_ENTREPRISE + 3) — Onglet Coût (PRD AC-SESSION-02.6). */
export const MAX_SESSION_FINANCING_MODES = 4;

/** Field length limits on the create/edit form (PRD AC-PARAM-03.1). */
export const FINANCING_MODE_NAME_MAX_LENGTH = 45;
export const FINANCING_MODE_DESCRIPTION_MAX_LENGTH = 300;

/** Builds the custom technical code for a 1-based slot index. */
export const buildCustomFinancingModeCode = (slot: number): string => `${CUSTOM_FINANCING_MODE_CODE_PREFIX}${slot}`;

/** Next free custom slot number, derived from the technical codes already in use. */
export const nextCustomFinancingModeSlot = (codes: string[]): number => {
  const usedSlots = codes
    .filter((code) => code.startsWith(CUSTOM_FINANCING_MODE_CODE_PREFIX))
    .map((code) => Number(code.slice(CUSTOM_FINANCING_MODE_CODE_PREFIX.length)))
    .filter((slot) => Number.isInteger(slot));
  return (usedSlots.length ? Math.max(...usedSlots) : 0) + 1;
};
